export const SET_CHANNELS = "SET_CHANNELS";
export const SET_CHANNEL = "SET_CHANNEL";
export const ADD_NEW_CHANNEL = "ADD_NEW_CHANNEL";
export const CLEAR_CHANNEL = "CLEAR_CHANNEL";
